/*
*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  // Add custom code below this line
 // Deze code zet het aantal op 10 ipv van 5.
document.addEventListener("DOMContentLoaded", function () {

  function forceQuantity() {
    const input = document.querySelector('[data-quantity-field]');
    const titleEl = document.querySelector('.product__title');

    if (!input || !titleEl) return;

    const title = titleEl.textContent.toLowerCase();

    const isFabric =
      title.includes('french terry') ||
      title.includes('tricot') ||
      title.includes('jersey');

    if (!isFabric) return;

    // 👉 altijd naar 10 zetten als lager
    if (parseInt(input.value, 10) === 5) {
      input.value = 10;

      // 🔥 TRIGGERS (dit was je missing link)
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // 🔁 meerdere momenten (ivm app)
  setTimeout(forceQuantity, 100);
  setTimeout(forceQuantity, 400);
  setTimeout(forceQuantity, 700);

});


  /*function setCartMessage() {
  const el = document.getElementById("cart-urgency-message");
  if (!el) return false;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const country = Shopify.country || 'NL';

      let threshold;
      if (country === 'BE') {
        threshold = 85;
      } else if (country === 'DE') {
        threshold = 100;
      } else {
        threshold = 75;
      }

      const cartTotal = cart.total_price / 100;

      let hasFabric = false;
      let hasTransfer = false;

      cart.items.forEach(item => {
        const title = item.product_title.toLowerCase();

       const fabricKeywords = [
  'french terry',
  'tricot',
  'jersey',
  'boord',
  'boordstof',
  'rib',
  'ribstof'
];

if (fabricKeywords.some(k => title.includes(k))) {
  hasFabric = true;
}

        if (title.includes('transfer')) {
          hasTransfer = true;
        }
      });

      let line1 = "";
      let line2 = "";

      // ========================
      // FABRIC
      // ========================
      if (hasFabric) {

        if (cartTotal < 30) {
          line1 = "✔ Een mooi begin voor je volgende project";

        } else if (cartTotal < 50) {
          line1 = "✔ Goede combinatie";

        } else if (cartTotal < threshold) {
          const diff = Math.ceil(threshold - cartTotal);
          line1 = "✔ Bijna compleet";
          line2 = `✔ Nog €${diff} tot gratis verzending`;

        } else {
          line1 = "✔ Mooie bestelling zo";
          line2 = "✔ Gratis verzending";
        }

      } else {
        // ========================
        // TRANSFERS
        // ========================
        line1 = "✔ Combineer voor het beste effect";
        line2 = "✔ Levertijd + 3–5 werkdagen";
      }

      // ========================
      // OUTPUT
      // ========================
      el.innerHTML = line2
        ? `${line1}<br><span class="cart-subline">${line2}</span>`
        : line1;

    });

  return true;
}


// ========================
// INIT
// ========================
function trySetMessage() {
  let tries = 0;

  const interval = setInterval(() => {
    const el = document.getElementById("cart-urgency-message");

    if (el) {
      setCartMessage();
      clearInterval(interval);
    }

    tries++;
    if (tries > 10) clearInterval(interval);
  }, 100);
}

function initCartMessage() {
  trySetMessage();

  document.body.addEventListener("click", function() {
    setTimeout(setCartMessage, 200);
  });
}

document.addEventListener("DOMContentLoaded", initCartMessage);

// 🔥 reageer op quantity change in cart

document.addEventListener('change', function(e) {

  if (e.target.matches('[data-quantity-field]')) {

    setTimeout(updateCartMessage, 200);

  }

});*/

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();